import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SubmissionService} from '../submission.service';

@Component({
    selector: 'app-submission-detail',
    templateUrl: './submission-detail.component.html',
    styleUrls: ['./submission-detail.component.scss'],
    standalone: false
})
export class SubmissionDetailComponent implements OnInit {
  id: string;

  constructor(public route: ActivatedRoute, public SubmissionsService: SubmissionService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params.id;
      if (this.id !== 'new') {
        this.SubmissionsService.loadSubmission(this.id);
      } else {
        this.SubmissionsService.currentSubmission = {};
      }
    });

  }

  saveSubmission(value) {
    if (value === 'notif') {
      this.SubmissionsService.currentSubmission.submission_content = 'notif';
    } else if (value === 'monitor') {
      this.SubmissionsService.currentSubmission.submission_content = 'monitor';
    } else if (value === 'Update-Insert') {
      this.SubmissionsService.currentSubmission.submissiontype = 'Update-Insert';
    } else if (value === 'Delete') {
      this.SubmissionsService.currentSubmission.submissiontype = 'Delete';
    }

    if (this.SubmissionsService.currentSubmission.globalid !== undefined) {
      this.SubmissionsService.currentSubmission.save();
    }
  };
}
